import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { IUserCreate, IUserDetail, IUserList, IUserUpdate } from '../models/user-mgmt';

@Injectable({
  providedIn: 'root',
})
export class UserMgmtService {
  constructor(private apiService: ApiService) {}
  readonly usersRoot = 'api/users';

  public getUsers() {
    const fullAPIUrl = this.apiService.buildFullURL(this.usersRoot, '');
    return this.apiService.get<IUserList[]>(fullAPIUrl, { withCredentials: true });
  }

  public getUserById(id: string) {
    const userId = id;
    const fullAPIUrl = this.apiService.buildFullURL(this.usersRoot, `${userId}/`);
    return this.apiService.get<IUserDetail>(fullAPIUrl, { withCredentials: true });
  }

  public createUser(user: IUserCreate) {
    const fullAPIUrl = this.apiService.buildFullURL(this.usersRoot, '');
    return this.apiService.post<IUserCreate>(fullAPIUrl, user, { withCredentials: true });
  }
  public updateUser(user: IUserUpdate) {
    const userId = user.id.toString();
    const fullAPIUrl = this.apiService.buildFullURL(this.usersRoot, `${userId}/`);
    return this.apiService.patch<IUserUpdate>(fullAPIUrl, user, { withCredentials: true });
  }

  public deleteUser(id: number) {
    const userId = id;
    const fullAPIUrl = this.apiService.buildFullURL(this.usersRoot, `${userId}/`);
    return this.apiService.delete(fullAPIUrl, { withCredentials: true });
  }

  public reactivateUser(id: number) {
    const userId = id;
    const fullAPIUrl = this.apiService.buildFullURL(this.usersRoot, `${userId}/reactivate/`);
    return this.apiService.post<IUserDetail>(fullAPIUrl, {}, { withCredentials: true });
  }

  public getMeUser() {
    const fullAPIUrl = this.apiService.buildFullURL(this.usersRoot, 'me/');
    return this.apiService.get<IUserDetail>(fullAPIUrl, { withCredentials: true });
  }
}
